import PropTypes from "prop-types"
import classnames from "classnames"
import { IconButton, Card, CardHeader, Slide } from "@mui/material"
import { Close } from "@mui/icons-material"
import "./styles.scss"

function SideSheet({ children, open, title, onClose, subheader }) {
  return <Slide in={open} direction="left">
    <Card raised className={classnames("components_material_side-sheet", { open })}>
      <CardHeader
        className="side-sheet-header"
        title={title}
        subheader={subheader}
        action={
          <IconButton className="close-icon" onClick={onClose} size="large">
            <Close />
          </IconButton>
        }
      />
      {children}
    </Card>
  </Slide>
}

SideSheet.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  subheader: PropTypes.string,
}

export default SideSheet
